import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import userSelectors from 'store/user/selectors';

import {
  PercentText,
  NoPercentText,
} from './StartPercentText.styles';

export class StartPercentText extends Component {
  render() {
    const { quiz, statsByQuiz } = this.props;
    const score = statsByQuiz[quiz.id] ? Math.round((
      (statsByQuiz[quiz.id].correct / statsByQuiz[quiz.id].total_questions)
        * 100))
      : null;

    return statsByQuiz[quiz.id]
      ? (
        <PercentText score={score}>
          { `${score}%` }
        </PercentText>)
      : (<NoPercentText>
          ...
      </NoPercentText>);
  }
}

StartPercentText.propTypes = {
  quiz: PropTypes.object.isRequired,
  statsByQuiz: PropTypes.object,
};

export default connect((state) => {
  return {
    statsByQuiz: userSelectors.selectedUserStatsByQuizCompleted(state),
  };
}, {
})(StartPercentText);
